<template>
  <div class="">
    <panel Title="نمایش و دانلود PDF" Des="از طریق این فرم فایل pdf  گردش حساب شما به صورت خودکار دانلود و پیش نمایش آن قابل مشاهده است" :IsBtnBack="false" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
    <div id="Turnover-PDF">
      <div class="row mb-2">
        <div class="col-12 col-md-6 text-center" >
          <h6>{{ Taahod.vcodeDesNo }} {{ Taahod.desNo }}</h6>
          <h6>{{ Taahod.nameFamily }}</h6>
        </div>
        <div class="col-12 col-md-6 text-center"><h6>{{ $session.get('NameSandogh') }}</h6></div>
      </div>
      <table  class="table table-striped table-light text-center">
      <thead>
        <tr style="border-bottom: 3px double #000">
          <th scope="col">شرح سند</th>
          <th scope="col">تاریخ تراکنش</th>
          <th scope="col">تراکنش</th>
          <th scope="col">واریز</th>
          <th scope="col">برداشت</th>
          <th scope="col">مانده</th>
        </tr>
      </thead>
      <tbody>
        <tr class="" v-for="(item, key) in Rows" :key="key">
          <th scope="row">{{ item.sharh }}</th>
          <th scope="row">{{ item.tarix }}</th>
          <th scope="row">{{ item.amaliyat }}</th>
          <th scope="row">{{ item.bestan }}</th>
          <th scope="row">{{ item.bedeh }}</th>
          <th scope="row">{{ item.mande }}</th>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
</template>
<script>
import html2pdf from 'html2pdf.js'
import Panel from '../Tools/NetPa/Panel.vue'

export default {
    
  setup() {
    return {}
  },
  props: ['Rows','Taahod'],
  mounted() {
    if (this.Rows && this.Rows.length > 0) {
      html2pdf(document.getElementById('Turnover-PDF'), {
        margin: 1,
        filename: 'generated-pdf.pdf',
      })
      
    } else {
      this.$router.go(-1)
    }
  },
  components: {
    Panel
  },
}
</script>
